import cookie from "react-cookies";
import { LanguageSelectionHelper } from "./languageSelectionHelper";
//
export class PersistLanguageHelper {
  static syncLanguageWithPublicView = () => {
    // check default language getting sent from 3et-ui to public-ui
    // if language different from default language, save it to cookie
    const pathParts = window.location.pathname.split("/lang=");
    let lang: string | null = null;
    if (pathParts.length > 1) {
      lang = pathParts[1].split("/")[0];
    }
    let languageStoredInCookie =
      LanguageSelectionHelper.checkCookieLanguageSelected();

    // if lang is not null
    if (lang !== null) {
      // check  if lang is not the same value as cookie value
      if (lang !== languageStoredInCookie) {
        // clearing cookie language selection
        cookie.remove("language", {
          path: "/",
        });
        LanguageSelectionHelper.saveLanguageToCookie(lang);
        // save language changed flag to cookie
        LanguageSelectionHelper.saveLanguageChangedToCookie(true);
      }
    }
  };
}
